(function ($) {
  'use strict';
  jQuery(document).ready(function() {
    // menu toggler js
    $('button.navbar-toggle').on('click', function() {
      $('.main-menu-area').addClass('active');
      $('.mm-fullscreen-bg').addClass('active');
      $('body').addClass('ov-hidden');
    });
    $('.close-box').on('click', function() {
      $('.main-menu-area').removeClass('active');
      $('.mm-fullscreen-bg').removeClass('active');
      $('body').removeClass('ov-hidden');
    });
    // filter button js
    $('button.filter-button').on('click', function() {
      $('.filter-sidebar').addClass('active');
      $('.mm-fullscreen-bg').addClass('active');
    });
    $('button.close-filter-sidebar').on('click', function() {
      $('.filter-sidebar').removeClass('active');
      $('.mm-fullscreen-bg').removeClass('active');
    });
    // body background color js
    $('.mm-fullscreen-bg').on('click',function() {
      $('.main-menu-area').removeClass('active');
      $('.filter-sidebar').removeClass('active');
      $('.mm-fullscreen-bg').removeClass('active');
      $('body').removeClass('hidden');
    });
    $('.checkout-btn .read-agree').on('click', function () {
      if($('.cust-checkbox').is(':checked')) {
        $('.checkout-btn button.check-btn').removeAttr('disabled');
      }
      else {
        $('.checkout-btn button.check-btn').attr('disabled', 'disabled');
      }
    });
    $('.read-agree').on('click', function () {
      if($('.create-checkbox').is(':checked')) {
        $('.create').removeAttr('disabled');
      }
      else {
        $('.create').attr('disabled', 'disabled');
      }
    });
    // SUNBORN 9/4: PDP lightbox -- fixed to work with BOTH gallery layouts.
    //
    // BUG FOUND VIA LIVE BROWSER TEST (not guessed): this handler never
    // called e.preventDefault(). The elements it binds to (.zoom, .full-
    // view) sit INSIDE the <a href="[raw image URL]"> anchor rendered by
    // snippets/media.liquid. Without preventDefault, the anchor's own
    // default navigation fires in the same event alongside our
    // .magnificPopup('open') call -- and the browser's native "go to
    // this image URL" navigation wins the race every time, so the
    // lightbox never had a chance to render. FIXED + VERIFIED LIVE 9/4:
    // real click no longer navigates away, .mfp-wrap/.mfp-close/
    // .mfp-counter/.mfp-arrow all confirmed present and visible via
    // direct DOM inspection after a real dispatched click.
    //
    // ROOT CAUSE (separate, found earlier same session): this handler
    // always targeted $('.product_img_top'), which only exists in
    // Swiper-mode gallery markup. Grid mode (sections/product-
    // template.liquid, gallery_layout=='grid') renders
    // .sb-pdp-gallery-grid instead -- fixed via .closest() below so this
    // works identically regardless of which layout is active.
    //
    // tCounter lives INSIDE the `gallery` sub-object, not top-level --
    // Magnific Popup silently ignores a top-level tCounter and falls
    // back to its own default ("%curr% of %total%").
    //
    // SUNBORN 9/4 (round 2, Captain live-test): click-vs-drag on the
    // Grid gallery was finicky -- sometimes a mouse drag intended to
    // scroll the gallery instead opened the lightbox. ROOT CAUSE: the
    // browser's own "suppress click after a drag" heuristic doesn't
    // reliably coordinate with a custom pointer-based scroll handler
    // (see the drag-to-scroll block below) -- it's based on total
    // cursor movement, which can vary in a way that doesn't match user
    // intent. FIX: track drag distance ourselves in the scroll handler
    // and stamp a `data-sb-just-dragged` attribute on the gallery
    // container the instant a real drag (>3px movement) ends. This
    // handler checks that attribute FIRST and bails out (without
    // opening the popup) if it's set, then the attribute is cleared on
    // a short timeout so it doesn't affect the NEXT unrelated click.
    // Deterministic, not dependent on browser click-suppression
    // heuristics.
    //
    // SUNBORN 9/6 (round 4, Captain report): lightbox always opened on
    // the FIRST gallery image no matter which grid cell was clicked.
    // ROOT CAUSE, confirmed by reading Magnific Popup's own API: this
    // handler calls `.magnificPopup('open')` with NO index argument.
    // Per MFP's public API, `.magnificPopup('open', index)` takes the
    // starting index as its SECOND argument -- omitting it defaults to
    // 0 every time, regardless of which delegate `<a>` the click
    // actually originated from, because the popup is opened here via a
    // direct method call (constructor + `.open()` in the same handler)
    // rather than letting MFP's own internal delegated-click listener
    // fire and resolve the index itself. This bug existed identically
    // for BOTH gallery layouts (Swiper and Grid), since they share this
    // one handler -- Grid mode just made it obvious because every image
    // is visible and clickable at once, so a wrong-index open is
    // immediately, unmistakably wrong.
    //
    // FIX: before opening, walk up from whatever was clicked (.zoom is
    // the innermost element; .full-view may be applied elsewhere) to
    // its containing gallery-item `<a>`, then find that anchor's
    // position among every `<a>` inside this same gallery container
    // (the exact same element set MFP's `delegate: 'a'` option matches
    // against) via jQuery's `.index()`. That position is passed as the
    // starting index to `.magnificPopup('open', clickedIndex)`, so the
    // lightbox now opens on the actual image that was clicked. Falls
    // back to index 0 only if no matching anchor is found at all (e.g.
    // a future markup change breaks the anchor structure), so this can
    // never throw or silently do nothing -- worst case it reverts to
    // the old (still-functional, just wrong-index) behavior.
    $(document).on('click', '.full-view, .zoom', function(e) {
      e.preventDefault();
      var $galleryContainer = $(this).closest('.product_img_top, .sb-pdp-gallery-grid');
      if (!$galleryContainer.length) return;
      if ($galleryContainer.attr('data-sb-just-dragged') === 'true') {
        return;
      }
      var $clickedAnchor = $(this).closest('a');
      var clickedIndex = 0;
      if ($clickedAnchor.length) {
        var $allAnchors = $galleryContainer.find('a');
        var foundIndex = $allAnchors.index($clickedAnchor);
        if (foundIndex > -1) {
          clickedIndex = foundIndex;
        }
      }
      $galleryContainer.magnificPopup({
        delegate: 'a',
        type: 'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
          tCounter: '%curr% / %total%'
        }
      }).magnificPopup('open', clickedIndex);
    });

    // SUNBORN 9/13: PDP lightbox -- mobile swipe navigation.
    //
    // Magnific Popup (the library behind the lightbox above) ships NO
    // built-in touch/swipe gesture support -- confirmed by reading its
    // source and its own docs. Without this, the only way to move
    // between images once the lightbox is open is tapping the small
    // .mfp-arrow-left/.mfp-arrow-right buttons (see
    // sunborn-pdp-lightbox.css) or a keyboard, neither of which is a
    // natural mobile interaction once you're already inside a
    // fullscreen image viewer.
    //
    // Implementation: delegated touch listeners on `document`, scoped
    // to `.mfp-wrap` (MFP's own outer container, present only while a
    // popup is open -- so this is a no-op everywhere else on the site).
    // Track the horizontal + vertical distance of each touch gesture;
    // on touchend, if the horizontal distance clears both an absolute
    // threshold (40px -- enough to distinguish an intentional swipe
    // from an accidental finger drift) AND is clearly more horizontal
    // than vertical (abs(dx) > abs(dy)), advance the gallery via MFP's
    // own public API (`$.magnificPopup.instance.next()` / `.prev()`) --
    // left swipe advances to the next image, right swipe goes back,
    // matching every native mobile gallery/camera-roll convention.
    // Single-touch only (ignores multi-finger gestures, e.g. pinch-
    // zoom, so this never fights native pinch-to-zoom on the image).
    (function () {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchTracking = false;
      var SWIPE_THRESHOLD = 40;

      $(document).on('touchstart', '.mfp-wrap', function (e) {
        var touches = e.originalEvent.touches;
        if (!touches || touches.length !== 1) {
          touchTracking = false;
          return;
        }
        touchTracking = true;
        touchStartX = touches[0].clientX;
        touchStartY = touches[0].clientY;
      });

      $(document).on('touchend', '.mfp-wrap', function (e) {
        if (!touchTracking) return;
        touchTracking = false;

        var touches = e.originalEvent.changedTouches;
        if (!touches || touches.length !== 1) return;

        var dx = touches[0].clientX - touchStartX;
        var dy = touches[0].clientY - touchStartY;

        if (Math.abs(dx) < SWIPE_THRESHOLD) return;
        if (Math.abs(dx) <= Math.abs(dy)) return; // more vertical than horizontal -- not a nav swipe

        if (!$.magnificPopup.instance) return;

        if (dx < 0) {
          $.magnificPopup.instance.next();
        } else {
          $.magnificPopup.instance.prev();
        }
      });
    })();

    $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
      tClose: 'Close (Esc)',
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });

    // SUNBORN 9/4: Grid gallery mouse drag-to-scroll.
    //
    // BUG FOUND VIA LIVE BROWSER TEST: on mobile widths (<=749px),
    // sunborn-pdp-gallery-grid.css turns .sb-pdp-gallery-grid into a
    // horizontal overflow-x:auto scroll-snap row. That works perfectly
    // for a REAL touchscreen swipe -- native browser touch scrolling
    // handles it with zero JS. But `overflow: auto` containers do NOT
    // respond to mouse click-and-drag in any browser -- only an actual
    // touch/trackpad gesture, a scrollbar-thumb drag, or custom JS can
    // move them. Confirmed live: dragging with the mouse left scrollLeft
    // at 0 every time without this. Verified live (round 1) that a
    // realistically-paced pointerdown -> pointermove x N -> pointerup
    // sequence genuinely moves scrollLeft once scroll-snap-type is
    // disabled during the drag (see .sb-grid-dragging in
    // sunborn-pdp-gallery-grid.css) -- scroll-snap-type:x mandatory was
    // otherwise snapping any JS-set scrollLeft straight back to 0.
    //
    // Scoped to pointerType === 'mouse' only -- real touch/pen input is
    // deliberately left alone so native touch scrolling (with its
    // momentum/inertia) keeps working exactly as before.
    //
    // SUNBORN 9/4 (round 2): now also tracks whether THIS gesture
    // crossed the drag threshold at all (hasDraggedThisGesture), and
    // stamps `data-sb-just-dragged` on the container when it did, so
    // the lightbox click handler above can deterministically tell a
    // real drag apart from a real click -- see that handler's comment
    // for why this replaced relying on the browser's own heuristic.
    (function () {
      var el = document.querySelector('.sb-pdp-gallery-grid');
      if (!el) return;

      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var hasDraggedThisGesture = false;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        hasDraggedThisGesture = false;
        el.classList.add('sb-grid-dragging');
        startX = e.clientX;
        startScrollLeft = el.scrollLeft;
      });

      el.addEventListener('pointermove', function (e) {
        if (!isDown || e.pointerType !== 'mouse') return;
        var delta = e.clientX - startX;
        if (Math.abs(delta) > 3) {
          hasDraggedThisGesture = true;
          e.preventDefault();
          el.scrollLeft = startScrollLeft - delta;
        }
      });

      function sbEndGridDrag(e) {
        if (e && e.pointerType && e.pointerType !== 'mouse') return;
        isDown = false;
        el.classList.remove('sb-grid-dragging');
        if (hasDraggedThisGesture) {
          el.setAttribute('data-sb-just-dragged', 'true');
          setTimeout(function () {
            el.removeAttribute('data-sb-just-dragged');
          }, 50);
        }
        hasDraggedThisGesture = false;
      }
      el.addEventListener('pointerup', sbEndGridDrag);
      el.addEventListener('pointerleave', sbEndGridDrag);
      el.addEventListener('pointercancel', sbEndGridDrag);
    })();

    // SUNBORN 9/4 (session 3, extended session 4): Grid gallery -- release
    // scroll to the page near the edges of the gallery pane (desktop/
    // tablet split layout, >=992px, .sb-pdp-gallery-scrollpane -- see the
    // max-height/overflow rules in sunborn-pdp-gallery-grid.css). Matches
    // the common comp pattern where a sticky, independently-scrolling
    // gallery column blends into normal page scroll near the edges of
    // its own content, instead of staying locked inside its own scroll
    // box until the literal first/last pixel. Two asymmetric release
    // zones, both per Captain's direction:
    //  - DOWN: releases over the last ~2 rows of the grid. Row-count
    //    based (not percentage) because it's keyed to when the LAST
    //    photos physically come into view -- a constant regardless of
    //    how many total images the gallery has.
    //  - UP: releases once scrolled back up past the gallery's own
    //    scrollable MIDPOINT (50%), so the page (header, hero, etc.)
    //    becomes reachable again well before the customer has to
    //    fully re-scroll the whole gallery back to image 1. Percentage-
    //    based here since "the middle" was the explicit ask, and unlike
    //    the downward case there's no fixed visual landmark (like "the
    //    last photos") to key off of.
    // Outside both zones the pane scrolls entirely on its own via the
    // browser's normal overflow-y:auto handling -- no JS involved, this
    // listener just returns immediately. Row height for the downward
    // zone is measured live off the actual rendered cells (2-column
    // grid, so cell index 0 and index 2 sit exactly one row apart)
    // rather than hardcoded, so it keeps working if grid_image_ratio or
    // grid_gap settings change.
    (function () {
      var el = document.querySelector('.sb-pdp-gallery-scrollpane');
      if (!el) return;

      function sbGalleryRowHeight() {
        var cells = el.querySelectorAll('.sb-pdp-grid-cell');
        if (cells.length < 3) return 400; // fallback for very short galleries
        return cells[2].getBoundingClientRect().top - cells[0].getBoundingClientRect().top;
      }

      el.addEventListener('wheel', function (e) {
        // SUNBORN 9/4 (session 5 fix): gate on actual overflow state
        // instead of a viewport-width media query -- scrollHeight only
        // exceeds clientHeight when the CSS breakpoints that make this
        // pane scrollable are actually in effect, so this is equivalent
        // but immune to any mismatch between JS's and CSS's read of the
        // current breakpoint.
        if (el.scrollHeight <= el.clientHeight) return;

        if (e.deltaY > 0) {
          // Scrolling DOWN -- release to the page over the last ~2 rows.
          var remainingDown = el.scrollHeight - el.scrollTop - el.clientHeight;
          if (remainingDown <= 0) return; // already at the very bottom -- native chaining handles it
          var releaseZoneDown = sbGalleryRowHeight() * 2;
          if (remainingDown > releaseZoneDown) return; // not near the end yet -- let the pane scroll normally

          // SUNBORN 9/4 (session 5 fix): Captain reported scrolling felt
          // "extremely slow" in the release zone (worse going up, some
          // going down). ROOT CAUSE: the previous version SPLIT deltaY
          // between the container and the page (toContainer + toPage ==
          // deltaY), which sounds harmless on paper, but the gallery pane
          // is position:sticky and stays visually pinned on screen while
          // the page scrolls underneath it -- so the "toPage" portion of
          // every wheel tick was invisible to the eye (it just moved the
          // buy-box/footer somewhere off to the side), while the ONLY
          // visible signal (the photos themselves scrolling) was
          // throttled down to the shrinking "toContainer" fraction, all
          // the way to near-zero right as you approached the edge. Fix:
          // stop splitting. Give the container the FULL native-feeling
          // delta every time (so the photos never feel throttled), and
          // treat the page-scroll as an ADDITIONAL boost layered on top
          // (not stolen from the container), scaling up the closer you
          // get to the edge, so the page is already gaining momentum by
          // the time the container truly runs out.
          e.preventDefault();
          el.scrollTop += e.deltaY;
          var tDown = 1 - (remainingDown / releaseZoneDown);
          window.scrollBy(0, e.deltaY * tDown);
          return;
        }

        if (e.deltaY < 0) {
          // Scrolling UP -- release to the page once past the gallery's
          // own scrollable midpoint, so the page keeps scrolling up
          // toward the top instead of the customer having to fully
          // exhaust the gallery's internal scroll first.
          var totalScrollable = el.scrollHeight - el.clientHeight;
          if (totalScrollable <= 0) return;
          if (el.scrollTop <= 0) return; // already at the top -- native chaining handles it
          var midPoint = totalScrollable / 2;
          if (el.scrollTop > midPoint) return; // still in the bottom half -- let the pane scroll normally

          // Same fix as the downward case: full-speed container scroll,
          // additive (not subtractive) page boost.
          e.preventDefault();
          el.scrollTop += e.deltaY;
          var tUp = 1 - (el.scrollTop / midPoint);
          window.scrollBy(0, e.deltaY * tUp);
          return;
        }
      }, { passive: false });
    })();

    // SUNBORN 9/4 (session 3, FIXED session 4): Grid gallery -- vertical
    // drag-to-scroll for tablet/touchscreen users on the desktop-width
    // split layout (>=992px, .sb-pdp-gallery-scrollpane). Native touch
    // scrolling inside a position:sticky + overflow-y:auto pane is a
    // documented WebKit/iOS Safari trouble spot -- same reasoning as
    // the mouse-only horizontal drag handler above, applied to the
    // opposite input type. Scoped to pointerType !== 'mouse' (touch +
    // pen); mouse users keep native wheel/scrollbar behavior (see the
    // release-zone handler above). touch-action: none on
    // .sb-pdp-gallery-scrollpane at >=992px (see CSS) stops the
    // browser's own touch scroll from fighting this handler.
    //
    // SESSION 4 FIX -- Captain reported the touch drag simply didn't
    // scroll. ROOT CAUSE: this handler never captured the pointer.
    // Without setPointerCapture, pointermove events are delivered based
    // on live hit-testing at the finger's current position -- the
    // instant a touch drag (which tends to be faster and less strictly
    // vertical than a mouse drag) crosses outside this pane's bounding
    // box even briefly, subsequent pointermove events get delivered to
    // whatever element the finger is now over instead of `el`, and this
    // listener silently stops receiving them. The mouse-only horizontal
    // handler above never hit this because mouse drags stay inside a
    // tracked element far more reliably than a touch swipe does. Fix:
    // explicitly capture the pointer on pointerdown so every subsequent
    // event for that pointer routes to `el` regardless of where the
    // finger physically is, and release capture on pointerup/cancel.
    // Also added: the same click-vs-drag disambiguation the horizontal
    // handler already has (data-sb-just-dragged), stamped on the INNER
    // .sb-pdp-gallery-grid rather than this outer pane -- the lightbox
    // click handler's .closest() match stops at .sb-pdp-gallery-grid,
    // so stamping the flag anywhere else would never be seen by it,
    // and a vertical drag ending over a photo could pop the lightbox
    // open unintentionally.
    (function () {
      var el = document.querySelector('.sb-pdp-gallery-scrollpane');
      if (!el) return;
      var innerGrid = el.querySelector('.sb-pdp-gallery-grid');

      var isDown = false;
      var startY = 0;
      var startScrollTop = 0;
      var hasDraggedThisGesture = false;
      var activePointerId = null;

      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        // SUNBORN 9/4 (session 5 fix): dropped the viewport-width media
        // query gate that was here -- Captain reported touch drag still
        // wasn't landing after the session 4 pointer-capture fix. Root
        // cause candidate: this pane is only made scrollable by CSS at
        // >=992px, so gating the JS on the SAME breakpoint via
        // matchMedia should be redundant with the scrollHeight check
        // below -- but real devices can report viewport width in ways
        // that don't line up cleanly with a fixed number (browser UI
        // chrome, zoom level, split-screen multitasking on iPad, etc.),
        // and any mismatch here silently kills the whole handler before
        // it ever attaches. The scrollHeight check is authoritative --
        // it's true if and only if the CSS already made this element
        // overflow-scrollable, regardless of what number the viewport
        // reports -- so it's both correct and now the ONLY gate.
        if (el.scrollHeight <= el.clientHeight) return; // nothing to scroll
        isDown = true;
        hasDraggedThisGesture = false;
        startY = e.clientY;
        startScrollTop = el.scrollTop;
        activePointerId = e.pointerId;
        try {
          el.setPointerCapture(e.pointerId);
        } catch (err) {}
      });

      el.addEventListener('pointermove', function (e) {
        if (!isDown || e.pointerType === 'mouse') return;
        if (e.pointerId !== activePointerId) return;
        var delta = e.clientY - startY;
        if (Math.abs(delta) > 2) {
          hasDraggedThisGesture = true;
          e.preventDefault();
          el.scrollTop = startScrollTop - delta;
        }
      }, { passive: false });

      function sbEndGalleryVScroll(e) {
        if (e && e.pointerType === 'mouse') return;
        if (e && e.pointerId !== undefined && e.pointerId !== activePointerId) return;
        isDown = false;
        if (activePointerId !== null) {
          try {
            el.releasePointerCapture(activePointerId);
          } catch (err) {}
        }
        if (hasDraggedThisGesture && innerGrid) {
          innerGrid.setAttribute('data-sb-just-dragged', 'true');
          setTimeout(function () {
            innerGrid.removeAttribute('data-sb-just-dragged');
          }, 50);
        }
        hasDraggedThisGesture = false;
        activePointerId = null;
      }
      el.addEventListener('pointerup', sbEndGalleryVScroll);
      el.addEventListener('pointerleave', sbEndGalleryVScroll);
      el.addEventListener('pointercancel', sbEndGalleryVScroll);
    })();

    // SUNBORN: swatch click handler + variant sync to quickview/ATC fetch URL (8/16, corrected)
    // + quick-cart-button variant sync (8/17, session 7).
    // ROOT CAUSE: quick-add and quickview both fetch a static data-product-url with no
    // variant param, built at page load. Updating a data attribute nobody reads does
    // nothing. The fix is to rewrite data-product-url itself so the modal fetches the
    // swatch-selected variant's rendering. Same swatch click ALSO now updates the
    // sunborn-quick-cart-button's hidden variant id, so if a color was picked before
    // tapping the plain cart icon (relevant for "direct" mode -- see below), it adds
    // that color's default/first-available size.
    //
    // SunBorn 8/17 (session 10, Option A): the "modal" this comment refers to no longer
    // opens as a quickview overlay -- see sbNavigateToPdp() below. data-product-url is
    // STILL kept in sync here because it's now the source of truth for which URL those
    // three navigation call-sites send the customer to, so arriving on the PDP already
    // reflects the color they'd picked on the card.
    $('.item-data').on('click', function() {
      var $item = $(this);
      var $productWrap = $item.parents('.single-product-wrap');
      var variantId = ($item.attr('id') || '').split('-').pop();
      var it_img = $item.attr('dataimg');
      var price = $item.attr('dataprice');
      var compareprice = $item.attr('datacompare');
      $item.parents('.option-block').find('.variant-option').removeClass('active-variant');
      $item.closest('form-wrap').addClass('active-variant');
      $productWrap.find('.product-image .img1 img').attr('src', it_img);
      $productWrap.find('.product-image .img1 img').attr('srcset', it_img);
      $productWrap.find('.price-box .new-price').text(Shopify.formatMoney(price, window.money_format));
      if (compareprice > price) {
        $productWrap.find('.price-box .old-price').show();
        $productWrap.find('.price-box .old-price').html(Shopify.formatMoney(compareprice, window.money_format));
      } else {
        $productWrap.find('.price-box .old-price').hide();
      }
      if (variantId) {
        var $urlLinks = $productWrap.find('a[data-product-url]');
        $urlLinks.each(function() {
          var $link = $(this);
          var baseUrl = $link.attr('data-product-url');
          if (!baseUrl) return;
          baseUrl = baseUrl.replace(/[&?]variant=\d+/, '');
          var separator = baseUrl.indexOf('?') > -1 ? '&' : '?';
          $link.attr('data-product-url', baseUrl + separator + 'variant=' + variantId);
        });
        $productWrap.find('.sb-quick-cart-variant-input').val(variantId);
      }
    });

    // SUNBORN 8/17 (session 10, Option A): shared PDP-navigation helper.
    // Replaces the old "click the hidden .quick-add-btn to open the
    // quickview modal" pattern used by three separate features (sp-badge,
    // quick-size Set fallback pill, quick-cart-button "modal" mode).
    //
    // WHY: Baymard Institute's large-scale moderated usability testing
    // found quick-view overlays add friction without a corresponding UX
    // benefit -- users routinely mistook the overlay for the actual PDP
    // and struggled to navigate out of it. Confirmed live that Gymshark
    // (closest working comp, including their two-piece matching-set
    // products) uses ZERO quickview modal anywhere in their grid --
    // every click, including "quick add," resolves to a real PDP
    // navigation. Captain's call 8/17: eliminate the modal fallback
    // entirely rather than rebuild it on-brand, since a polished modal
    // still doesn't fix the structural "mistaken for PDP" problem, and
    // every future Kinetic Engine / fabric-brand copy update would need
    // to be kept in sync in two places instead of one.
    //
    // Reads data-product-url off the SAME .quick-add-btn element the old
    // code used to .click() -- that attribute is still the single source
    // of truth for "which variant is currently selected on this card"
    // (kept live by the swatch handler above), so this preserves the
    // color-aware handoff to the PDP that the modal used to provide.
    // Strips the quickview-only `view=main-product` param (meaningless,
    // and confusing, on a real page load) while preserving any
    // `variant=` param.
    //
    // popup-view / quickview-button.liquid's modal shell is left in the
    // DOM (see that file's own updated doctrine comment) but is now
    // ORPHANED -- nothing calls .click() on its trigger anymore as of
    // this change. Safe to delete in a future cleanup pass; left in
    // place today to avoid touching that fragile shared markup for no
    // functional gain.
    function sbNavigateToPdp($productImage) {
      var trigger = $productImage.find('.quick-add-btn').get(0);
      var url = trigger ? trigger.getAttribute('data-product-url') : null;
      if (!url) return;
      url = url.replace(/([?&])view=main-product&?/, '$1').replace(/[?&]$/, '');
      window.location.href = url;
    }

    // SUNBORN: SP badge click -> local +1 count (Option A: localStorage,
    // per-visitor persistence, no backend) then navigates straight to the
    // PDP (8/17, session 10 -- previously opened the quick-add modal; see
    // sbNavigateToPdp() above for why that changed). Verified working via
    // direct DOM test: count increments and persists before the
    // navigation fires.
    //
    // Storage key format: sb_sp_clicks_{productId} -> integer delta.
    // Displayed count = server-rendered data-base-count + stored delta.
    // Wrapped in try/catch since localStorage can throw in private/
    // restricted browsing contexts -- if that happens the navigation
    // still fires, the count just doesn't persist for that visitor.
    function sbSpStorageKey(productId) {
      return 'sb_sp_clicks_' + productId;
    }

    function sbSpReadDelta(productId) {
      try {
        var raw = window.localStorage.getItem(sbSpStorageKey(productId));
        var n = parseInt(raw, 10);
        return isNaN(n) ? 0 : n;
      } catch (e) {
        return 0;
      }
    }

    function sbSpIncrementDelta(productId) {
      try {
        var next = sbSpReadDelta(productId) + 1;
        window.localStorage.setItem(sbSpStorageKey(productId), next);
        return next;
      } catch (e) {
        return null;
      }
    }

    function sbSpHandleBadgeActivate($badge) {
      var productId = $badge.attr('data-product-id');
      var baseCount = parseInt($badge.attr('data-base-count'), 10) || 0;

      if (productId) {
        var newDelta = sbSpIncrementDelta(productId);
        if (newDelta !== null) {
          var $count = $badge.find('.sb-sp-badge-count');
          $count.text(baseCount + newDelta);
          $badge.addClass('sb-sp-badge--bump');
          setTimeout(function () {
            $badge.removeClass('sb-sp-badge--bump');
          }, 350);
        }
      }

      var $productImage = $badge.closest('.product-image');
      sbNavigateToPdp($productImage);
    }

    $(document).on('click', '.sb-sp-badge', function (e) {
      e.preventDefault();
      sbSpHandleBadgeActivate($(this));
    });

    // Keyboard activation (Enter / Space) since the badge is role="button"
    $(document).on('keydown', '.sb-sp-badge', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        sbSpHandleBadgeActivate($(this));
      }
    });

    // SUNBORN: quick-size overlay pill click -> set the hidden variant id
    // input on the real Shopify product form inside <cart-action>, then
    // submit it (8/17, session 7). No custom AJAX/fetch is written here --
    // <cart-action>'s own constructor (plugins.js, class stProductForm)
    // already listens for the form's native submit event and handles the
    // add + cart-drawer refresh + drawer open. This handler's only job is
    // picking which variant that submit is for. This remains the ONLY
    // place a size actually gets added from the grid card.
    $(document).on('click', '.sb-quick-size-pill:not(.sb-quick-size-pill--fallback):not(:disabled)', function (e) {
      e.preventDefault();
      var $pill = $(this);
      var variantId = $pill.attr('data-variant-id');
      if (!variantId) return;

      var $cartAction = $pill.closest('cart-action');
      var $form = $cartAction.find('form');
      if (!$form.length) return;

      $form.find('input[name="id"]').val(variantId);

      $pill.siblings('.sb-quick-size-pill').removeClass('sb-quick-size-pill--selected');
      $pill.addClass('sb-quick-size-pill--selected');
      $cartAction.addClass('sb-quick-size--loading');
      setTimeout(function () {
        $cartAction.removeClass('sb-quick-size--loading');
      }, 2500);

      // Adding via a real pill closes any forced-open state the quick-cart
      // icon may have triggered (8/17, session 8).
      $pill.closest('.sb-quick-size').removeClass('sb-quick-size--forced-open');

      var formEl = $form.get(0);
      if (formEl.requestSubmit) {
        formEl.requestSubmit();
      } else {
        $(formEl).trigger('submit');
      }
    });

    // Two-piece Sets (Bra Size + Shorts Size) can't be fully specified by
    // one tap -- navigate straight to the PDP (8/17, session 10, Option A;
    // previously opened the quick-add modal -- see sbNavigateToPdp() above).
    // Sets carry the highest fit-risk in the catalog (two independent
    // sizing decisions), so this is deliberately the ONE case that always
    // gets the full PDP, never a cart shortcut -- see the size/fit-risk
    // return-rate research discussed with Captain 8/17.
    $(document).on('click', '.sb-quick-size-pill--fallback', function (e) {
      e.preventDefault();
      var $productImage = $(this).closest('.product-image');
      sbNavigateToPdp($productImage);
    });

    // SUNBORN: quick-cart icon click, Option B router (8/17, session 8),
    // PDP-routing update (8/17, session 10, Option A).
    //
    // BUG FIX (session 8, second pass): the button stays type="submit"
    // (required so Lume's <cart-action> constructor resolves its own
    // this.submitButton correctly -- see the comment in
    // sunborn-quick-cart-button.liquid for the full explanation of why a
    // plain type="button" broke native submission entirely). Because of
    // that, this handler does NOT call requestSubmit() itself and does
    // NOT preventDefault() unconditionally -- it only prevents the
    // default (native) submit for the two modes that must NOT add
    // anything yet. For "direct" mode it does nothing and lets the
    // button's own native type="submit" click behavior fire the form
    // exactly like Lume's own PDP add-to-cart button does.
    //
    // Liquid computes a mode per product (data-mode) based on its actual
    // option structure:
    //
    //  "direct" -- no size dimension exists on this product (single SKU,
    //    or color-only variance). Nothing to gate on, so this is the only
    //    mode that's allowed to actually submit the form and add to cart.
    //  "reveal" -- exactly one size option exists; the quick-size overlay
    //    for this same card already has real, tappable size pills.
    //    Force that overlay open (desktop convenience -- mobile already
    //    shows it persistently) and STOP. No add happens here; the
    //    customer must tap an actual pill (handled above), which is the
    //    only thing that ever calls requestSubmit() in this mode.
    //  "modal" -- 2+ size options (two-piece Sets). As of session 10,
    //    navigates straight to the PDP via sbNavigateToPdp() instead of
    //    opening the quickview modal -- see that function's doctrine
    //    comment for the full rationale (Baymard research + Gymshark comp
    //    confirmation + Set fit-risk).
    //
    // Confirmed against 5 comp sites (Gymshark, Alo, Nike, lululemon,
    // Represent) that none of them let a click add a product without a
    // size being chosen first -- this router enforces the same rule.
    $(document).on('click', '.sb-quick-cart-btn', function (e) {
      var $btn = $(this);
      if ($btn.is(':disabled') || $btn.attr('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }

      var mode = $btn.attr('data-mode');
      var $wrap = $btn.closest('.single-product-wrap');

      if (mode === 'reveal') {
        e.preventDefault();
        var $overlay = $wrap.find('.sb-quick-size').first();
        if (!$overlay.length) return;
        // Toggle: a second click on an already-open overlay closes it again.
        if ($overlay.hasClass('sb-quick-size--forced-open')) {
          $overlay.removeClass('sb-quick-size--forced-open');
        } else {
          $overlay.addClass('sb-quick-size--forced-open');
        }
        return;
      }

      if (mode === 'modal') {
        e.preventDefault();
        sbNavigateToPdp($wrap.find('.product-image').first());
        return;
      }

      // mode === 'direct' (or unset, fail-safe default): do NOT
      // preventDefault -- let the native type="submit" click proceed so
      // Lume's own cart-action listener (bound to the real submitButton
      // it found at construction time) handles the add + drawer open.
    });

    // Close any forced-open size overlay when the user clicks elsewhere
    // on the page, so it doesn't stay stuck open (8/17, session 8).
    $(document).on('click', function (e) {
      if ($(e.target).closest('.sb-quick-size, .sb-quick-cart-btn').length) return;
      $('.sb-quick-size--forced-open').removeClass('sb-quick-size--forced-open');
    });

    // SUNBORN: quick-cart-button visual feedback (8/17, session 7-8).
    // Only fires for "direct" mode submissions, since that's the only
    // mode whose native submit is ever allowed through. Bag icon swaps
    // to a checkmark for ~1.6s after submit, then reverts. Timing-based
    // since we don't hook into cart-action's own fetch promise (would
    // mean touching plugins.js, which we don't do).
    $(document).on('submit', '.sb-quick-cart-form', function () {
      var $btn = $(this).find('.sb-quick-cart-btn');
      $btn.addClass('sb-quick-cart-btn--loading');
      setTimeout(function () {
        $btn.removeClass('sb-quick-cart-btn--loading');
        $btn.addClass('sb-quick-cart-btn--added');
        setTimeout(function () {
          $btn.removeClass('sb-quick-cart-btn--added');
        }, 1600);
      }, 500);
    });

    var swiper = new Swiper('.drawer-slider', {
      slidesPerView: 1,
      grid: {
        rows: 1,
        fill: 'row' | 'column',
      },
      spaceBetween: 30,
      navigation: {
        nextEl: '.arrow-next-drawer',
        prevEl: '.arrow-prev-drawer',
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      speed: 1000,
    });
  });
})(jQuery);
